import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const stationsApi = createApi({
    reducerPath: 'stationsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}/pos`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getStations: builder.query({
            query: () => ({
                url: `/stations?perPage=all`, // update URL as per your API endpoint
                method: 'GET',
            }),
            // Uncomment and update as needed:
            // transformResponse: (resp) => transformResponseHandler(resp),
            providesTags: ['Stations'],
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addStations: builder.mutation({
            query: (body) => ({
                url:'/stations',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Stations'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateStations: builder.mutation({
            query: ({id, ...body}) => ({
                url:`/stations/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Stations'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteStations: builder.mutation({
            query: (id) => ({
                url: `/stations/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Stations'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        assignChefs: builder.mutation({
            query: ({id, body}) => ({
                url: `/stations/assignChefs/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['Stations'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        availableChefs: builder.query({
            query: (stationId) => ({
                url: `/stations/avaliableChefs`,
                method: 'GET',
            }),
            // providesTags: ['Stations'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const { 
    useAddStationsMutation,
    useUpdateStationsMutation,
    useGetStationsQuery,
    useDeleteStationsMutation,
    useAssignChefsMutation,
    useAvailableChefsQuery
 } = stationsApi;
